"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("~components");

var styles = _interopRequireWildcard(require("./styles.module.scss"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** ============================================================================
 * Slice
 */


var ImageGrid = function ImageGrid(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$data = _ref.data,
      backgroundColor = _ref$data.backgroundColor,
      padded = _ref$data.padded,
      dockedTop = _ref$data.dockedTop,
      dockedBottom = _ref$data.dockedBottom,
      images = _ref$data.images; //

  if (!(images !== null && images !== void 0 && images[0])) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("section", {
    sliceid: id,
    className: [className, styles.container, dockedTop ? styles.dockedTop : "", dockedBottom ? styles.dockedBottom : "", padded ? styles.padded : ""].join(" "),
    style: {
      background: (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex) || "transparent"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.grid
  }, images.map(function (image) {
    return /*#__PURE__*/_react.default.createElement("figure", {
      key: image._key,
      className: styles.figure
    }, /*#__PURE__*/_react.default.createElement(_components.Image, {
      className: styles.image,
      image: image
    }));
  })));
};

var _default = ImageGrid;
exports.default = _default;